const ERROR_CODES = {
  IS_ALREADY_PAID: '080002',
  IS_ALREADY_CANCELED: '080001',
};

export default ERROR_CODES;
